export enum ClientApiActions {
  LoadClientSuccess = '[Clients Api] Load Client Success',
  LoadClientFailure = '[Clients Api] Load Client Failure',

  LoadClientSuccessWithRelationshipChecks = '[Clients API] Load Client Success With Relationship Checks',

  // Below indicates the the app would benefit from an additional endpoint
  LoadPrimaryClientSuccess = '[Clients API] Load Primary Client Success',
  LoadPrimaryClientFailure = '[Clients API] Load Primary Client Failure',

  LoadClientSubClientSuccess = '[Clients Api] Load Client Sub Clients Success',
  LoadClientSubClientFailure = '[Clients Api] Load Client Sub Clients Failure',

  LoadClientsSuccess = '[Clients Api] Load Clients Success',
  LoadClientsFailure = '[Clients Api] Load Clients Failure',

  LoadClientAndSubClientsSuccess = '[Clients Api] Load Client And Sub Clients Success',
  LoadClientAndSubClientsFailure = '[Clients Api] Load Client And Sub Clients Failure',

  PrimaryClientAddedSuccess = '[Clients Api] Primary Client Added Success',
  PrimaryClientAddedFailure = '[Clients Api] Primary Client Added Failure',

  SecondaryClientAddedSuccess = '[Clients Api] Secondary Client Added Success',
  SecondaryClientAddedFailure = '[Clients Api] Secondary Client Added Failure',

  SecondaryClientsAddedComplete = '[Clients Api] Secondary Clients Added Complete',

  ClientDataAddedComplete = '[Clients Api] Client Data Added Complete',

  ClientAddedSuccess = '[Clients Api] Client Added Success',
  ClientAddedFailure = '[Clients Api] Client Added Failure',

  ClientUpdatedSuccess = '[Clients Api] Client Updated Success',
  ClientUpdatedFailure = '[Clients Api] Client Updated Failure',
}
